import { Component, defineComponent } from 'vue';
import MainContent from '@/presentation/components/main-content/main-content.vue';
import Modal from '@/presentation/components/modal/modal.vue';
import AppComponent from '@/presentation/app-class';

export default defineComponent({
	components: {
		Modal: Modal as Component,
		MainContent: MainContent as Component
	},
	setup: () => {
		const code = new AppComponent();

		return {
			isModalActive: code.isModalActive,
			routeIsListing: code.routeIsListing
		};
	}
});
